import React from 'react';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import { Tooltip } from '@mui/material';
import AudioRecorder from './AudioRecorder';
import { stopAudioPlayback, stopStream } from 'src/components/SproutsAgent/utils';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'src/app/rootStore';
import {
  setChatStreaming,
  toggleAudioVisualizer,
} from 'src/store/sprouts-agent/sprouts-agent.slice';
import { sproutsAgentSelector } from 'src/store/sprouts-agent/sprouts-agent.selector';
import Lottie from 'lottie-react';
import PaulaAnimation from 'src/lottie-animations/PaulaAnimation.json';
interface AudioProps {
  audioRef: any;
  handleTimeUpdateRef: any;
  abortControllerRef: any;
}
const Audio: React.FC<AudioProps> = ({ audioRef, handleTimeUpdateRef, abortControllerRef }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { chatStreaming } = useSelector(sproutsAgentSelector);
  return (
    <div className="voice-section">
      <div style={{ height: '60px', width: '60px', marginLeft: '-68px' }}>
        <Lottie animationData={PaulaAnimation} loop={true} autoplay={true} />
      </div>
      <AudioRecorder
        abortControllerRef={abortControllerRef}
        audioRef={audioRef}
        handleTimeUpdateRef={handleTimeUpdateRef}
      />
      <div className="action-btns">
        <Tooltip title="Interrupt Agent" placement="top">
          <div
            className={`voice-action ${!chatStreaming && 'disable-btn'}`}
            onClick={() => {
              stopAudioPlayback(handleTimeUpdateRef, audioRef, dispatch, abortControllerRef);
              stopStream(dispatch);
              dispatch(setChatStreaming(false));
            }}
          >
            <DoDisturbIcon />
          </div>
        </Tooltip>
        <Tooltip title="Stop Agent" placement="top">
          <div
            className="voice-action"
            onClick={() => {
              stopAudioPlayback(handleTimeUpdateRef, audioRef, dispatch, abortControllerRef);
              stopStream(dispatch);
              dispatch(toggleAudioVisualizer(false));
            }}
          >
            <StopCircleIcon />
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default Audio;
